import api from './client';

export const purchaseApi = {
  locations:        (params?: any) => api.get('/locations', { params }),
  addLocation:      (data: any)    => api.post('/locations', data),
  branches:         ()             => api.get('/branches'),
  orders:           (params?: any) => api.get('/purchase-orders', { params }),
  createOrder:      (data: any)    => api.post('/purchase-orders', data),
  getOrder:         (id: number)   => api.get(`/purchase-orders/${id}`),
  grns:             (params?: any) => api.get('/grns', { params }),
  createGrn:        (data: any)    => api.post('/grns', data),
  confirmGrn:       (id: number, data?: any) => api.post(`/grns/${id}/confirm`, data ?? {}),
  getLandedCosts:   (id: number)   => api.get(`/grns/${id}/landed-costs`),
  addLandedCost:    (id: number, data: any) => api.post(`/grns/${id}/landed-costs`, data),
  deleteLandedCost: (grnId: number, costId: number) => api.delete(`/grns/${grnId}/landed-costs/${costId}`),
  importPreview:    (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/grns/import-preview', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  importSave:          (grnId: number, data: any) => api.post(`/grns/${grnId}/import-save`, data),
  supplierInvoices:    (params?: any) => api.get('/supplier-invoices', { params }),
  createSupplierInvoice: (data: any) => api.post('/supplier-invoices', data),
  supplierPayments:    () => api.get('/supplier-payments'),
  createSupplierPayment: (data: any) => api.post('/supplier-payments', data),
  cashAccounts:    ()          => api.get('/purchase/cash-accounts'),
  cashPurchase:    (data: any) => api.post('/purchase/cash-purchase', data),
  enterBill:       (data: any) => api.post('/purchase/bills', data),
  getBill:         (id: number)            => api.get(`/purchase/bills/${id}`),
  updateBill:      (id: number, data: any) => api.put(`/purchase/bills/${id}`, data),
  recentCash:      (params?: any)          => api.get('/purchase/cash-purchases', { params }),
  getCash:         (id: number)            => api.get(`/purchase/cash-purchases/${id}`),
  updateCash:      (id: number, data: any) => api.put(`/purchase/cash-purchases/${id}`, data),
  voidBill:        (id: number, data?: any) => api.post(`/purchase/bills/${id}/void`, data ?? {}),
  voidCash:        (id: number, data?: any) => api.post(`/purchase/cash-purchases/${id}/void`, data ?? {}),
};
